import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function AdminHeader({ title, testid, backTo = "/admin", backTestid = "admin-header-back", eyebrow = "Admin", actions = null, maxW = "max-w-5xl" }) {
  const navigate = useNavigate();
  return (
    <header className="bg-white/85 backdrop-blur-md border-b border-slate-200 sticky top-0 z-20" data-testid="admin-header">
      <div className={`${maxW} mx-auto px-4 py-3 flex items-center gap-3 flex-wrap`}>
        <button onClick={() => navigate(backTo)} data-testid={backTestid} aria-label="Back"
          className="h-11 w-11 grid place-items-center rounded-lg hover:bg-slate-100 press">
          <ChevronLeft className="h-5 w-5 text-[#0F2547]" />
        </button>
        <div className="min-w-0">
          <p className="text-[10px] font-bold uppercase tracking-wider text-slate-400 leading-none mb-0.5" data-testid="admin-header-eyebrow">
            {eyebrow}
          </p>
          <h1 className="font-heading text-xl sm:text-2xl font-bold text-[#0F2547] leading-tight truncate" data-testid={testid}>{title}</h1>
        </div>
        {actions && <div className="ml-auto flex gap-2 flex-wrap items-center">{actions}</div>}
      </div>
    </header>
  );
}
